import { Selector } from 'reselect'
import { createDeepEqualSelector } from 'Redux/selectors/index'

import { CampaignsState } from 'Redux/reducers/campaignReducer'

type TState = {
  campaigns: CampaignsState
}

const getState: Selector<TState, CampaignsState> = state => state.campaigns

export const getCampaigns = createDeepEqualSelector(
  getState,
  ({ campaigns }) => campaigns
)

export const getCampaignsLoader = createDeepEqualSelector(
  getState,
  ({ loading }) => loading
)

export const getPrescheduleValues = createDeepEqualSelector(
  getState,
  ({ preschedule }) => preschedule
)
export const getConnections = createDeepEqualSelector(
  getState,
  ({ connections }) => connections
)

export const getInfoTiktokCampaignDetails = createDeepEqualSelector(
  getState,
  ({ detailsTiktok }) => detailsTiktok
)

export const getInfoTiktokCampaignEvents = createDeepEqualSelector(
  getState,
  ({ eventsTiktok }) => eventsTiktok
)

export const getInfoTiktokEventCancel = createDeepEqualSelector(
  getState,
  ({ tiktokCancel }) => tiktokCancel
)

export const getSfaEmail = createDeepEqualSelector(
  getState,
  ({ sfa_email }) => sfa_email
)

export const getAmountOfCampaigns = createDeepEqualSelector(
  getState,
  ({ amountOfCampaigns }) => amountOfCampaigns
)

export const getCampaignToSchedule = createDeepEqualSelector(
  getState,
  ({ campaignToSchedule }) => campaignToSchedule?.campaign
)
